document.addEventListener('DOMContentLoaded',()=>{
  const toggle=(selector,target)=>{
    document.querySelectorAll(selector).forEach(btn=>{
      btn.addEventListener('click',()=>{
        const el=document.querySelector(target);
        if(el) el.classList.toggle('is-open');
      });
    });
  };
  document.querySelectorAll('[data-mobile-menu-toggle]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const nav=document.querySelector('[data-mobile-nav]');
      if(nav){const open=nav.classList.toggle('is-open');btn.classList.toggle('is-open',open);btn.setAttribute('aria-expanded',open?'true':'false');}
    });
  });
  toggle('[data-search-toggle]','[data-search-panel]');
  toggle('[data-filter-toggle]','[data-filters]');

  document.addEventListener('click',(e)=>{
    const nav=document.querySelector('[data-mobile-nav]');
    const menuBtn=document.querySelector('[data-mobile-menu-toggle]');
    if(nav && nav.classList.contains('is-open') && !nav.contains(e.target) && !menuBtn.contains(e.target)){
      nav.classList.remove('is-open');
      if(menuBtn){menuBtn.classList.remove('is-open');menuBtn.setAttribute('aria-expanded','false');}
    }
  });

  document.querySelectorAll('[data-product-form]').forEach(form=>{
    form.addEventListener('submit',async(e)=>{
      e.preventDefault();
      const button=form.querySelector('.add-to-cart');
      const original=button?.textContent;
      if(button){button.disabled=true;button.textContent='Adding...';}
      try{
        const response=await fetch(window.Shopify.routes.root+'cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8','Accept':'application/json'},
          body:new URLSearchParams(new FormData(form))
        });
        if(!response.ok) throw new Error('Cart error');
        const cart=await fetch(window.Shopify.routes.root+'cart.js').then(r=>r.json());
        document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
        if(button){button.textContent='Added ✓';setTimeout(()=>{button.textContent=original;button.disabled=false},1200);}
      }catch(err){
        if(button){button.textContent='Try Again';button.disabled=false;}
      }
    });
  });
});

/* =========================================================
   CHAINSONLY - CATEGORY SLIDER
========================================================= */

(function () {

  function initCategorySliders(root) {

    var sections = root.querySelectorAll
      ? root.querySelectorAll('[data-category-section]')
      : [];

    sections.forEach(function (section) {

      if (section.dataset.sliderReady === 'true') {
        return;
      }

      if (section.dataset.layout !== 'slider') {
        return;
      }

      var track = section.querySelector('[data-category-track]');
      var prev = section.querySelector('[data-category-prev]');
      var next = section.querySelector('[data-category-next]');
      var dots = section.querySelector('[data-category-dots]');

      if (!track) {
        return;
      }

      section.dataset.sliderReady = 'true';


      /* -----------------------------------------
         GET SLIDE WIDTH
      ----------------------------------------- */

      function getStep() {

        var item = track.querySelector('.chain-category');

        if (!item) {
          return 300;
        }

        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 0);

        return item.getBoundingClientRect().width + gap;
      }


      /* -----------------------------------------
         ARROW NAVIGATION
      ----------------------------------------- */

      if (prev) {

        prev.addEventListener('click', function (event) {

          event.preventDefault();

          track.scrollBy({
            left: -getStep(),
            behavior: 'smooth'
          });

        });

      }


      if (next) {

        next.addEventListener('click', function (event) {

          event.preventDefault();

          track.scrollBy({
            left: getStep(),
            behavior: 'smooth'
          });

        });

      }


      /* -----------------------------------------
   SMOOTH FREE DRAG
----------------------------------------- */

var isDragging = false;
var startX = 0;
var startScrollLeft = 0;
var dragDistance = 0;

track.addEventListener('mousedown', function (event) {

  if (event.button !== 0) {
    return;
  }

  isDragging = true;
  dragDistance = 0;

  startX = event.pageX;
  startScrollLeft = track.scrollLeft;

  track.classList.add('is-dragging');

});


track.addEventListener('mousemove', function (event) {

  if (!isDragging) {
    return;
  }

  event.preventDefault();

  var currentX = event.pageX;

  var distance = currentX - startX;

  dragDistance = Math.abs(distance);

  /*
    1:1 movement with mouse.
    No jumping from one slide to another.
  */
  track.scrollLeft =
    startScrollLeft - distance;

});


track.addEventListener('mouseup', function () {

  isDragging = false;

  track.classList.remove('is-dragging');

});


track.addEventListener('mouseleave', function () {

  if (!isDragging) {
    return;
  }

  isDragging = false;

  track.classList.remove('is-dragging');

});


/* Prevent opening a category when user dragged */

track.addEventListener('click', function (event) {

  if (dragDistance > 6) {

    event.preventDefault();

    event.stopPropagation();

    dragDistance = 0;

  }

}, true);


      /* -----------------------------------------
         PREVENT LINK CLICK AFTER DRAG
      ----------------------------------------- */

      track.addEventListener('click', function (event) {

        if (moved) {

          event.preventDefault();
          event.stopPropagation();

          moved = false;

        }

      }, true);


      /* -----------------------------------------
         TOUCH / MOBILE SWIPE
         Native horizontal scrolling handles this.
      ----------------------------------------- */


      /* -----------------------------------------
         DOTS
      ----------------------------------------- */

      function buildDots() {

        if (!dots) {
          return;
        }

        dots.innerHTML = '';

        var maxScroll =
          track.scrollWidth - track.clientWidth;

        if (maxScroll <= 5) {
          return;
        }

        var step = getStep();

        var count =
          Math.ceil(maxScroll / step) + 1;


        for (var i = 0; i < count; i++) {

          var dot =
            document.createElement('button');

          dot.type = 'button';

          dot.className =
            'chain-categories__dot';

          dot.setAttribute(
            'aria-label',
            'Go to category slide ' + (i + 1)
          );


          (function (index) {

            dot.addEventListener('click', function () {

              track.scrollTo({
                left: index * getStep(),
                behavior: 'smooth'
              });

            });

          })(i);


          dots.appendChild(dot);

        }

        updateDots();

      }


      /* -----------------------------------------
         ACTIVE DOT
      ----------------------------------------- */

      function updateDots() {

        if (!dots) {
          return;
        }

        var dotList =
          dots.querySelectorAll('.chain-categories__dot');

        if (!dotList.length) {
          return;
        }

        var step = getStep();

        var active =
          Math.round(track.scrollLeft / step);

        dotList.forEach(function (dot, index) {

          dot.classList.toggle(
            'is-active',
            index === active
          );

        });

      }


      track.addEventListener(
        'scroll',
        updateDots,
        { passive: true }
      );


      /* -----------------------------------------
         INITIALIZE
      ----------------------------------------- */

      buildDots();


      window.addEventListener(
        'resize',
        function () {
          buildDots();
        }
      );

    });

  }


  /* -----------------------------------------
     NORMAL PAGE LOAD
  ----------------------------------------- */

  document.addEventListener(
    'DOMContentLoaded',
    function () {

      initCategorySliders(document);

    }
  );


  /* -----------------------------------------
     SHOPIFY THEME EDITOR
  ----------------------------------------- */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initCategorySliders(event.target);

    }
  );


})();